import(/* webpackMode: "eager" */ "/Users/yoko/renehuemer.com/website/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/Users/yoko/renehuemer.com/website/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["ProjectInfoTable","LightboxProvider"] */ "/Users/yoko/renehuemer.com/website/src/components/lightbox-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/yoko/renehuemer.com/website/src/components/PrintGallery.tsx");
